/**
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { NgModule } from "@angular/core";
import { ClrDatagridModule } from "./datagrid/datagrid.module";
import { ClrStackViewModule } from "./stack-view/stack-view.module";
import { ClrTreeViewModule } from "./tree-view/tree-view.module";
var ClrDataModule = (function () {
    function ClrDataModule() {
    }
    return ClrDataModule;
}());
export { ClrDataModule };
ClrDataModule.decorators = [
    { type: NgModule, args: [{
                exports: [
                    ClrDatagridModule,
                    ClrStackViewModule,
                    ClrTreeViewModule
                ]
            },] },
];
/** @nocollapse */
ClrDataModule.ctorParameters = function () { return []; };
//# sourceMappingURL=data.module.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/data.module.js
// module id = 150
// module chunks = 4